import React from "react";

export function formatRepeatingZeroDecimal(num: number, maxDigits = 14, sigDigits = 4): React.ReactNode {
    if (!isFinite(num)) return "0";
    if (num === 0) return "0";

    if (num >= 1) {
        // For numbers >= 1, just trim to 4 digits after the decimal point and remove trailing zeros
        let trimmed = num
            .toFixed(sigDigits)
            .replace(/\.0+$/, "")
            .replace(/(\.\d*?[1-9])0+$/, "$1");
        return trimmed;
    }

    const str = num.toFixed(maxDigits + 2); // Extra digits to avoid rounding errors
    const match = str.match(/^0\.(0*)(\d+)/);
    if (!match) return num.toString();

    const zeros = match[1].length;
    // Remove all trailing zeros from digits before slicing
    let digits = match[2].replace(/0+$/, "").slice(0, sigDigits);

    // If all digits are zeros or empty, just return "0"
    if (!digits) return "0";

    return (
        <span>
            0.
            {zeros > 0 && <sub>{zeros}</sub>}
            {digits}
        </span>
    );
}
